import AdsError from './AdsError.js'

export class GetAdDetailsNotFoundError extends AdsError {
  constructor({message, status, origin}) {
    super()

    this.message = message
    this.status = status
    this.origin = origin
  }
}
